import React, { useContext } from 'react';
import { List } from '@sm/wds-react';
import { SubMenuLink } from './components/SubMenuLink';
import { SeeMoreLink } from './components/SeeMoreLink';
import {
  resources,
  blog,
  helpCenter,
  exploreSurveyTemplates,
} from '../../config/linkInfo.js';
import SMHeaderContext from '../../SMHeaderContext.js';

import './mobile-menu-anon.scss';

export const ResourcesMenu = () => {
  const { lang } = useContext(SMHeaderContext);

  const isEnglish = ['en', 'en-gb'].includes(lang);

  return (
    <List interactive transparent noRules>
      <If condition={isEnglish}>
        <SubMenuLink {...resources()} />
      </If>
      <SubMenuLink {...blog()} />
      <SubMenuLink {...helpCenter(lang)} />

      <If condition={isEnglish}>
        <SeeMoreLink {...exploreSurveyTemplates()} />
      </If>
    </List>
  );
};

export default ResourcesMenu;
